import { render, staticRenderFns } from "./zhuanyeku.vue?vue&type=template&id=2ccc0cac&scoped=true"
import script from "./zhuanyeku.vue?vue&type=script&lang=js"
export * from "./zhuanyeku.vue?vue&type=script&lang=js"
import style0 from "./zhuanyeku.vue?vue&type=style&index=0&id=2ccc0cac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccc0cac",
  null
  
)

export default component.exports